export default __webpack_public_path__ + "static/studio-1-3-ac54e101eda9b79ae3a617993777ded2.jpg";